import { useContext, useMemo } from 'react';

import { UserContext } from '../context/UserContext';
import { GEOFENCE_TYPE, GEOFENCE_NAME } from '../utils/geofence';

// The zone polygons drawn in /admin/geofences, pulled off the schemas record
// they're stored in. UserContext hydrates schemas from dexie when offline, so
// this keeps working in the survey app -- against whatever zones were cached
// at the last sync.
//
// Returns [] when the record doesn't exist yet, which every consumer treats as
// "geofencing isn't set up", not as "this plot belongs to no zone".

export const useGeofences = () => {
  const { schemas } = useContext(UserContext);

  return useMemo(() => {
    const found = schemas?.find(x => x.type === GEOFENCE_TYPE && x.name === GEOFENCE_NAME);
    return Array.isArray(found?.schema) ? found.schema : [];
  }, [schemas])
}
